import { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from 'utils/@reduxjs/toolkit';

import { AuthenticationState, OTPDelivery } from './interfaces';

export const initialState: AuthenticationState = {
  phone_number: '',
  transaction_id: '',
  isAuthenticated: false,
  otp_delivery: 'whatsapp',
  otp_token: '',
  group_id: '',
  group_code: null,
  isPostSubmissionLogin: false,
  isAllowChangePhoneNumber: false,
};
export const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    setIsAuthenticated(state, action: PayloadAction<boolean>) {
      state.isAuthenticated = action.payload;
    },
    setPhoneNumber(state, action: PayloadAction<string>) {
      state.phone_number = action.payload;
    },
    setGroupCode(state, action: PayloadAction<string>) {
      state.group_code = action.payload;
    },
    setTransactionId(state, action: PayloadAction<string>) {
      state.transaction_id = action.payload;
    },
    setGroupId(state, action: PayloadAction<string>) {
      state.group_id = action.payload;
    },
    setPostSubmissionLogin(state) {
      state.isPostSubmissionLogin = true;
    },
    setAllowChangePhoneNumber(state) {
      state.isAllowChangePhoneNumber = true;
    },
    resetAllowChangePhoneNumber(state) {
      state.isAllowChangePhoneNumber = initialState.isAllowChangePhoneNumber;
    },
    resetPostSubmissionLogin(state) {
      state.isPostSubmissionLogin = false;
    },
    resetAuthentication(state) {
      state.isAuthenticated = initialState.isAuthenticated;
      state.phone_number = initialState.phone_number;
      state.transaction_id = initialState.transaction_id;
      state.group_id = initialState.group_id;
    },
    setOTPDelivery(state, action: PayloadAction<OTPDelivery>) {
      state.otp_delivery = action.payload;
    },
    resetOTPDelivery(state) {
      state.otp_delivery = initialState.otp_delivery;
    },
    setOTPToken(state, action: PayloadAction<string>) {
      state.otp_token = action.payload;
    },
    resetOTPToken(state) {
      state.otp_token = initialState.otp_token;
    },
  },
});

export const {
  resetAuthentication,
  resetOTPDelivery,
  resetOTPToken,
  setIsAuthenticated,
  setOTPDelivery,
  setOTPToken,
  setGroupId,
  setPhoneNumber,
  setTransactionId,
  setGroupCode,
  setPostSubmissionLogin,
  setAllowChangePhoneNumber,
  resetAllowChangePhoneNumber,
  resetPostSubmissionLogin,
} = authenticationSlice.actions;

export default authenticationSlice.reducer;
